import React, { Fragment } from 'react';
import moment from 'moment';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { Tag } from 'antd';

import { getChartDataWithoutSelection, getChartDataWithSelection } from '../../ChartCalls';
import { getTranslationCache } from '../../../../../selectors/language';
import { ErrorComponent, NoRecordComponent } from '../../Utils';
import { defaultRefreshTime } from '../../constant.json';
import { arrayOfObjects } from '../../../Mock/MockJson';
import { ArrowDownOutlined, ArrowUpOutlined, BellFilled } from '@ant-design/icons';
import '../../CSS/style.css';
import { getCurrentTimezone } from '../../../../../selectors/layout';

class StatusCounter extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      counter: 0,
      uom: this.props.graphprops.uom ? this.props.graphprops.uom : '',
      statusCounter: 0,
      status: 'down',
      translationCache: props.translationCache || [],
      image: '',
      refreshDateTime: moment(),
      errorInAPI: false,
      noDataInDB: false
    };
  }

  timeTicket = null;
  requestCheck = true;
  abortController = new window.AbortController();
  async componentDidMount() {
    if (this.timeTicket) {
      clearInterval(this.timeTicket);
    }
    this.getData(this.props);

    let refreshTime = '';
    if (this.props.graphprops.refreshTime) {
      refreshTime = this.props.graphprops.refreshTime * 60000;
    } else {
      refreshTime = defaultRefreshTime;
    }

    this.timeTicket = setInterval(() => {
      if (this.requestCheck) {
        this.getData(this.props);
      }
    }, refreshTime);
  }

  componentWillUnmount() {
    this.abortController.abort();
    clearInterval(this.timeTicket);
  }
  componentDidUpdate(prevProps) {
    if (
      prevProps.graphprops !== this.props.graphprops ||
      prevProps.selectionDate !== this.props.selectionDate ||
      prevProps.selectionDateLive !== this.props.selectionDateLive ||
      prevProps.selectionMonth !== this.props.selectionMonth ||
      prevProps.selectionWeek !== this.props.selectionWeek ||
      prevProps.DeviceCode !== this.props.DeviceCode ||
      prevProps.shift !== this.props.shift ||
      prevProps.selectionDateRange !== this.props.selectionDateRange ||
      prevProps.dayMonthYear !== this.props.dayMonthYear ||
      prevProps.dropdownSelection !== this.props.dropdownSelection ||
      prevProps.dashboardPayload !== this.props.dashboardPayload ||
      prevProps.AssetCode !== this.props.AssetCode ||
      prevProps.translationCache !== this.props.translationCache
    ) {
      this.getData();
    }
  }

  render() {
    const { errorInAPI, noDataInDB, refreshDateTime } = this.state;
    let { graphprops } = this.props;
    return (
      <Fragment>
        {graphprops && graphprops.checked === true ? (
          <Tag className="graphTag" color="blue">
            {refreshDateTime ? moment(refreshDateTime).format('YYYY-MM-DD HH:mm:ss') : ''}
          </Tag>
        ) : null}
        {noDataInDB === true || errorInAPI === true ? (
          noDataInDB === true ? (
            <NoRecordComponent />
          ) : (
            <ErrorComponent />
          )
        ) : (
          <div
            className="statusCounter"
            style={{
              textAlign: 'center',
              backgroundColor:
                this.props.graphprops &&
                this.props.graphprops[graphprops.graph] &&
                this.props.graphprops[graphprops.graph].backgroundColor
                  ? this.props.graphprops[graphprops.graph].backgroundColor
                  : ''
            }}
          >
            <div
              style={{
                color:
                  this.props &&
                  this.props.graphprops &&
                  this.props.graphprops[graphprops.graph] &&
                  this.props.graphprops[graphprops.graph].titleColor
                    ? this.props.graphprops[graphprops.graph].titleColor
                    : 'steelblue',
                fontSize:
                  this.props &&
                  this.props.graphprops &&
                  this.props.graphprops[graphprops.graph] &&
                  this.props.graphprops[graphprops.graph].fontSize
                    ? this.props.graphprops[graphprops.graph].fontSize + 'em'
                    : '5em'
              }}
            >
              {this.props &&
              this.props.graphprops &&
              this.props.graphprops[graphprops.graph] &&
              this.props.graphprops[graphprops.graph].statusCounterType &&
              this.props.graphprops[graphprops.graph].statusCounterType === 'notification' ? (
                <div>
                  <BellFilled
                    style={{
                      marginRight: '4px',
                      fontWeight: '800',
                      fontSize: '0.8em',
                      color:
                        this.props.graphprops &&
                        this.props.graphprops[graphprops.graph] &&
                        this.props.graphprops[graphprops.graph].iconColor &&
                        this.props.graphprops[graphprops.graph].iconColor[0]
                          ? this.props.graphprops[graphprops.graph].iconColor[0]
                          : 'green'
                    }}
                  />
                  <span
                    style={{
                      color:
                        this.props.graphprops &&
                        this.props.graphprops[graphprops.graph] &&
                        this.props.graphprops[graphprops.graph].iconColor &&
                        this.props.graphprops[graphprops.graph].iconColor[0]
                          ? this.props.graphprops[graphprops.graph].iconColor[0]
                          : 'green'
                    }}
                  >
                    {this.state.counter}
                  </span>
                  <BellFilled
                    style={{
                      marginRight: '4px',
                      fontWeight: '800',
                      fontSize: '0.8em',
                      color:
                        this.props.graphprops &&
                        this.props.graphprops[graphprops.graph] &&
                        this.props.graphprops[graphprops.graph].iconColor &&
                        this.props.graphprops[graphprops.graph].iconColor[1]
                          ? this.props.graphprops[graphprops.graph].iconColor[1]
                          : 'red'
                    }}
                  />
                  <span
                    style={{
                      color:
                        this.props.graphprops &&
                        this.props.graphprops[graphprops.graph] &&
                        this.props.graphprops[graphprops.graph].iconColor &&
                        this.props.graphprops[graphprops.graph].iconColor[1]
                          ? this.props.graphprops[graphprops.graph].iconColor[1]
                          : 'red'
                    }}
                  >
                    {this.state.statusCounter}
                    {this.state.uom}
                  </span>
                </div>
              ) : this.props.graphprops &&
                this.props.graphprops[graphprops.graph] &&
                this.props.graphprops[graphprops.graph].statusCounterType &&
                this.props.graphprops[graphprops.graph].statusCounterType === 'Image & string' ? (
                <div style={{ display: 'flex', justifyContent: 'space-around' }}>
                  <div>
                    {this.state.counter}
                    {this.state.uom}
                  </div>

                  <span
                    style={{
                      justifyContent: 'center',
                      display: 'flex',
                      alignItems: 'center'
                    }}
                  >
                    <img
                      src={this.state.image ? this.state.image : ''}
                      type="image"
                      alt=""
                      style={{ height: '100px', width: '110px', marginTop: '7px' }}
                    />
                  </span>
                </div>
              ) : (
                <div style={{ display: 'flex', justifyContent: 'space-around' }}>
                  <div>
                    {this.state.counter}
                    {this.state.uom}
                  </div>
                </div>
              )}
            </div>

            {this.props.graphprops.graph === 'statusCounter' && this.state.status === 'High' ? (
              <div
                style={{
                  color:
                    this.props.graphprops[graphprops.graph] &&
                    this.props.graphprops[graphprops.graph].iconColor &&
                    this.props.graphprops[graphprops.graph].iconColor[0]
                      ? this.props.graphprops[graphprops.graph].iconColor[0]
                      : '#389e0d',
                  marginRight: '2%',
                  fontSize: '1.5em',
                  textAlign: 'center',
                  fontWeight: '600'
                }}
              >
                <ArrowUpOutlined
                  style={{
                    marginRight: '4px',
                    fontWeight: '800',
                    fontSize: '0.8em'
                  }}
                />
                {this.state.statusCounter} {this.state.uom}
              </div>
            ) : this.props.graphprops.graph === 'statusCounter' && this.state.status === 'Low' ? (
              <div
                style={{
                  color:
                    this.props.graphprops &&
                    this.props.graphprops[graphprops.graph] &&
                    this.props.graphprops[graphprops.graph].iconColor &&
                    this.props.graphprops[graphprops.graph].iconColor[0]
                      ? this.props.graphprops[graphprops.graph].iconColor[0]
                      : 'white',
                  marginRight: '2%',
                  fontSize: '1.5em',
                  textAlign: 'center',
                  fontWeight: '600'
                }}
              >
                <ArrowDownOutlined
                  style={{
                    marginRight: '4px',
                    fontWeight: '800',
                    fontSize: '0.8em'
                  }}
                />
                {this.state.statusCounter}
                {this.state.uom}
              </div>
            ) : this.props.graphprops.graph === 'statusCounter' && this.state.status === 'Equal' ? (
              <div
                style={{
                  color:
                    this.props.graphprops &&
                    this.props.graphprops[graphprops.graph] &&
                    this.props.graphprops[graphprops.graph].iconColor &&
                    this.props.graphprops[graphprops.graph].iconColor[0]
                      ? this.props.graphprops[graphprops.graph].iconColor[0]
                      : 'white',
                  marginRight: '2%',
                  fontSize: '1.5em',
                  textAlign: 'center',
                  fontWeight: '600'
                }}
              >
                {this.state.statusCounter}
                {this.state.uom}
              </div>
            ) : null}
          </div>
        )}
      </Fragment>
    );
  }

  getData = async () => {
    this.requestCheck = false;
    let { graphprops } = this.props;
    let json = [];
    let { errorInAPI, noDataInDB } = this.state;
    errorInAPI = false;
    noDataInDB = false;

    if (graphprops && graphprops.enableMock && graphprops.enableMock === true) {
      json = arrayOfObjects;
      this.requestCheck = true;
    } else {
      if (
        (graphprops &&
          (graphprops.DashboardLevelSelection === 'datePicker' ||
            graphprops.GraphLevelSelection === 'datePicker') &&
          this.props.selectionDate) ||
        (graphprops &&
          (graphprops.DashboardLevelSelection === 'monthPicker' ||
            graphprops.GraphLevelSelection === 'monthPicker') &&
          this.props.selectionMonth) ||
        (graphprops &&
          (graphprops.DashboardLevelSelection === 'weakPicker' ||
            graphprops.GraphLevelSelection === 'weakPicker') &&
          this.props.selectionWeek) ||
        (graphprops &&
          (graphprops.DashboardLevelSelection === 'shiftPicker' ||
            graphprops.GraphLevelSelection === 'shiftPicker') &&
          this.props.shift) ||
        (graphprops &&
          (graphprops.DashboardLevelSelection === 'dateRangePicker' ||
            graphprops.GraphLevelSelection === 'dateRangePicker') &&
          this.props.selectionDateRange) ||
        (graphprops &&
          (graphprops.DashboardLevelSelection === 'dateMonthYearPicker' ||
            graphprops.GraphLevelSelection === 'dateMonthYearPicker') &&
          this.props.dayMonthYear) ||
        (graphprops && graphprops.dashboardType === 'dynamic') ||
        (graphprops.dashboardType === 'dropdownHide' && this.props.DeviceCode) ||
        (graphprops && graphprops.dashboardType === 'hierarchy' && this.props.dropdownSelection) ||
        (graphprops && this.props.dashboardPayload) ||
        (graphprops && graphprops.treeExists === 'true' && this.props.AssetCode)
      ) {
        json = await getChartDataWithSelection({
          graphprops,
          DeviceCode: this.props.DeviceCode,
          selectionDate: this.props.selectionDate,
          selectionMonth: this.props.selectionMonth,
          selectionWeek: this.props.selectionWeek,
          shift: this.props.shift,
          selectionDateRange: this.props.selectionDateRange,
          dayMonthYear: this.props.dayMonthYear,
          abortController: this.abortController,
          dropdownSelection: this.props.dropdownSelection,
          dashboardPayload: this.props.dashboardPayload,
          AssetCode: this.props.AssetCode,
          selectionDateLive: this.props.selectionDateLive,
          currentTimeZone: this.props.currentTimeZone
        });
        this.requestCheck = true;
      } else {
        json = await getChartDataWithoutSelection({
          graphprops,
          abortController: this.abortController,
          dropdownSelection: this.props.dropdownSelection,
          DeviceCode: this.props.DeviceCode,
          TimeZone: this.props.currentTimeZone
        });
        this.requestCheck = true;
      }
    }
    // json = [
    //   {
    //     interval_alias: "2020-05-12T21:49:05.161Z",
    //     tagname: "TRR_TIC301_PV",
    //     tagvalue: 395.4,
    //     status: "Low",
    //     StatusValue: "54.0",
    //     tag_description: "Main stream temperature control",
    //   },
    // ];
    if (
      (json && json.message) ||
      (Array.isArray(json) && json.length === 0 && graphprops.enableMock !== true)
    ) {
      if (json.message) {
        errorInAPI = true;
      } else if (json.length === 0) {
        noDataInDB = true;
      }
    } else {
      if (
        json &&
        Array.isArray(json) &&
        json.length > 0 &&
        this.props.graphprops[graphprops.graph].statusCounterType === 'number'
      ) {
        this.setState({ counter: Number(json[0].Value).toFixed(2) });
        this.setState({
          statusCounter: json[0].StatusValue,
          status: json[0].Status
        });
      } else if (
        json &&
        Array.isArray(json) &&
        json.length > 0 &&
        this.props.graphprops[graphprops.graph].statusCounterType === 'string'
      ) {
        this.setState({ counter: json[0].Value });
        this.setState({
          statusCounter: json[0].StatusValue,
          status: json[0].Status
        });
      } else if (
        json &&
        Array.isArray(json) &&
        json.length > 0 &&
        this.props.graphprops[graphprops.graph].statusCounterType === 'both'
      ) {
        this.setState({
          uom: this.props.graphprops[graphprops.graph].uom,
          statusCounter: json[0].StatusValue,
          status: json[0].Status,
          counter: Number(json[0].Value).toFixed(2)
        });
      } else if (
        json &&
        Array.isArray(json) &&
        json.length > 0 &&
        this.props.graphprops[graphprops.graph].statusCounterType === 'notification'
      ) {
        this.setState({
          statusCounter: json[0].StatusValue,
          counter: Number(json[0].Value).toFixed(2)
        });
      } else if (
        json &&
        Array.isArray(json) &&
        json.length > 0 &&
        this.props.graphprops[graphprops.graph].statusCounterType === 'Image & string'
      ) {
        this.setState({
          status: json[0].Status,
          statusCounter: json[0].StatusValue,
          counter: json[0].Value,
          image: json[0].Description
        });
      }

      if (json && Array.isArray(json) && json[0] && json[0].Value === null) {
        this.setState({ errorInAPI, noDataInDB: !noDataInDB });
      } else {
        this.setState({ errorInAPI, noDataInDB });
      }
    }
  };
}

const mapStateToProps = createStructuredSelector({
  translationCache: getTranslationCache(),
  currentTimeZone: getCurrentTimezone()
});

export default connect(mapStateToProps)(StatusCounter);
